<template>
  <div
    class="description"
    :class="{
      adjust: isAdjustDescription,
    }"
  >
    <p>
      レイアウトはイメージです。実際は細かな配置や文字サイズを整えた状態での仕上がりとなります。
    </p>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    isAdjustDescription: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.description {
  margin-left: 50px;
  margin-right: 50px;
  color: red;
  font-weight: bold;

  &.adjust {
    margin-left: 10px;
    margin-right: 10px;
    font-size: 13px;
  }
}
</style>
